<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Product Report</legend>

            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group label-size="sm" label="From Date:" label-for="input-1">
                        <datepicker v-model="fromDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group label-size="sm" label="To Date:" label-for="input-1">
                        <datepicker v-model="toDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select to date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group label-size="sm" label="Completed Sale Successfully:">
                        <b-form-select v-model="success" size="sm">
                            <option :value="true">True</option>
                            <option :value="false">False</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <br />
                    <b-button type="button" @click="getReport" pill variant="outline-dark">
                        Retrieve Report
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Total Records : {{totalRecords}}</strong>
                </b-col>
            </b-row>

            <div class="row pt-3">
                <div class="table-responsive">
                    <b-table striped hover bordered :items="items" :fields="fields"></b-table>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>

            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
        </div>
    </main>
</div>
